import type { Task } from '../types'

export type TaskRole = 'bdr' | 'csr' | 'admin'

export function visibleTasks(tasks: Task[], role: TaskRole, currentUserId?: string) {
  const scoped = role === 'admin'
    ? tasks
    : tasks.filter(task => task.workspaceRole === role || (Boolean(currentUserId) && task.ownerUserId === currentUserId))
  return Object.freeze([...scoped].sort((left, right) => Number(left.completed) - Number(right.completed) || left.dueAt.localeCompare(right.dueAt) || left.title.localeCompare(right.title)))
}

export function taskSummary(tasks: readonly Task[]) {
  return Object.freeze({ total: tasks.length, open: tasks.filter(task => !task.completed).length, complete: tasks.filter(task => task.completed).length, unowned: tasks.filter(task => !task.owner).length })
}
